import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Route, Router} from '@angular/router';
import {AdminSchoolStudentService} from '../../../../../services/admin/admin-school-student.service';
import {StudentModel} from '../../../../../models/authentication/student.model';
import {ErrorModel} from '../../../../../models/shared/error.model';
import {ModalService} from '../../../../../shared/modals/modal/modal.service';
import {AdminStudentService} from '../../../../../services/admin/admin-student.service';
import {AdminSchoolService} from '../../../../../services/admin/admin-school.service';
import {SchoolModel} from '../../../../../models/school/school.model';
import {AdminSchoolSelectionService} from '../../../../shared/admin-school-selection/admin-school-selection.service';
import {EVOSegmentedControlItem} from '../../../../../shared/reusable-controls/evo-segmented-control/evo-segmented-control.component';

@Component({
  selector: 'app-evo-school-school-student-edit',
  templateUrl: './evo-admin-school-student-edit.component.html',
  styleUrls: ['./evo-admin-school-student-edit.component.css']
})
export class EvoAdminSchoolStudentEditComponent implements OnInit {

  isEditMode = false;
  schoolId: string;
  student = new StudentModel();
  SchoolTypes = StudentModel.SchoolTypesDropdownList;
  isUpdatingLocation = false;

  school: SchoolModel = null;

  controls: EVOSegmentedControlItem[] = [
    new EVOSegmentedControlItem('profile', 'Profile'),
    new EVOSegmentedControlItem('placementProgress', 'Placement Progress'),
  ];
  currentTab = this.controls[0];

  placementProgress: any = null;
  isLoadingPlacement = false;
  studentId: string;

  isCopyVisible = false;
  isCopying = false;
  copyFirstName = '';
  copyMiddleName = '';
  copyLastName = '';
  copySchool: SchoolModel = null;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private modalSv: ModalService,
              private studentSv: AdminStudentService,
              private schoolSv: AdminSchoolService,
              private schoolStudentService: AdminSchoolStudentService,
              private schoolSelectSv: AdminSchoolSelectionService) { }

  ngOnInit() {

    this.student.country = null;
    this.student.culture = null;

    this.route.params.subscribe((params: Params) => {

      this.schoolId = params.schoolId;
      if (params.studentId) {
        this.isEditMode = true;
        this.studentId = params.studentId;
        this.schoolStudentService.fetchSchoolStudentById(this.schoolId, params.studentId).subscribe((student) => {
          this.student = student;
        });
        this.schoolSv.fetchSchoolById(this.schoolId).subscribe((school) => {
          this.school = school;
        });
      }

    });

  }

  onTabChanged(tab: EVOSegmentedControlItem) {
    this.currentTab = tab;
    if (tab.key === 'placementProgress' && !this.placementProgress && !this.isLoadingPlacement) {
      this.isLoadingPlacement = true;
      this.studentSv.fetchPlacementProgress(this.studentId).subscribe((data) => {
        this.placementProgress = data;
        this.isLoadingPlacement = false;
      }, () => {
        this.isLoadingPlacement = false;
      });
    }
  }

  overallProgress(): number {
    if (!this.placementProgress || !this.placementProgress.placementTest) { return 0; }
    const state = this.placementProgress.state;
    const sections = this.placementProgress.placementTest.sections;
    let completed = 0;
    let total = 0;
    for (let i = 0; i < sections.length; i++) {
      const sectionLen = sections[i].orderedQuestions.length;
      total += sectionLen;
      if (i < state.currentSectionIndex) {
        completed += sectionLen;
      } else if (i === state.currentSectionIndex) {
        completed += state.currentQuestionIndex;
      }
    }
    return total === 0 ? 0 : Math.round((completed / total) * 100);
  }

  sectionStatus(sectionIndex: number): string {
    if (!this.placementProgress) { return 'notStarted'; }
    const idx = this.placementProgress.state.currentSectionIndex;
    if (sectionIndex < idx) { return 'done'; }
    if (sectionIndex === idx) { return 'inProgress'; }
    return 'notStarted';
  }

  sectionProgressText(sectionIndex: number): string {
    if (!this.placementProgress) { return ''; }
    const state = this.placementProgress.state;
    if (sectionIndex < state.currentSectionIndex) { return 'Done'; }
    if (sectionIndex === state.currentSectionIndex) {
      const total = this.placementProgress.placementTest.sections[sectionIndex].orderedQuestions.length;
      return state.currentQuestionIndex + ' / ' + total + ' questions';
    }
    return 'Not started';
  }

  questionMastery(questionId: string): string {
    if (!this.placementProgress) { return 'notReached'; }
    const answers = (this.placementProgress.answers || []).filter((a: any) => a.questionId === questionId);
    if (answers.length === 0) { return 'notReached'; }
    const seq = answers.map((a: any) => a.isCorrect ? 'C' : 'W').join('');
    if (/CC$/.test(seq)) { return 'mastered'; }
    if (/WW$/.test(seq)) { return 'failed'; }
    if (answers.length >= 4) { return 'partial'; }
    return 'active';
  }

  masteryLabel(mastery: string): string {
    switch (mastery) {
      case 'mastered': return 'Mastered';
      case 'failed': return 'Failed';
      case 'partial': return 'Partial';
      case 'active': return 'In Progress';
      default: return 'Not reached';
    }
  }

  masteryColor(mastery: string): string {
    switch (mastery) {
      case 'mastered': return '#28A745';
      case 'failed': return '#D0021B';
      case 'partial': return '#F26522';
      case 'active': return '#009CCC';
      default: return '#E0E0E0';
    }
  }

  title(): string {

    if (this.isEditMode === true) {
      return 'Update student';
    }

    return 'Create student';
  }

  saveButtonTitle(): string {

    if (this.isEditMode === true) {
      return 'Save';
    }

    return 'Create';
  }

  onSaveClicked() {

    this.schoolStudentService.updateSchoolStudents(this.schoolId, [this.student]).subscribe((students) => {

      this.router.navigate(['admin', 'schools', this.schoolId, 'students', students[0]._id, 'edit']);

    });

  }

  onResetLocationClicked() {

    this.student.evolytesProfile.unityLocation.x = 61.47;
    this.student.evolytesProfile.unityLocation.y = 47.61;
    this.student.evolytesProfile.unityMap = 'Island 1W';

    this.isUpdatingLocation = true;

    this.schoolStudentService.updateSchoolStudents(this.schoolId, [this.student]).subscribe((students) => {
      this.isUpdatingLocation = false;
      this.student = students[0];
      this.modalSv.showAlertModal('Success', 'student location updated');
    }, (err: ErrorModel) => {
      this.isUpdatingLocation = false;
      this.modalSv.showTranslatedErrorModal(err);
    });


  }

  onResetCrystalLocation() {

    this.student.evolytesProfile.unityCrystalLocation.x = 61.47;
    this.student.evolytesProfile.unityCrystalLocation.y = 47.61;
    this.student.evolytesProfile.unityMap = 'Island 1W';

    this.isUpdatingLocation = true;

    this.schoolStudentService.updateSchoolStudents(this.schoolId, [this.student]).subscribe((students) => {
      this.isUpdatingLocation = false;
      this.student = students[0];
      this.modalSv.showAlertModal('Success', 'student crystal location updated');
    }, (err: ErrorModel) => {
      this.isUpdatingLocation = false;
      this.modalSv.showTranslatedErrorModal(err);
    });

  }

  onRemoveTokensClicked() {

    this.studentSv.removeTokens(this.student._id).subscribe((student) => {
      this.modalSv.showAlertModal('Success', 'Tokens removed successfully');
    }, (err: ErrorModel) => {
      this.modalSv.showTranslatedErrorModal(err);
    });

  }

  onChangeSchoolsClicked() {

    this.schoolSelectSv.show(this.school.country).subscribe((schools) => {

      if (schools && schools.length > 0) {
        const newSchool = schools[0];
        this.schoolStudentService.changeSchool(this.schoolId, this.student._id, newSchool._id).subscribe((newStudent) => {
          this.router.navigate(['schools', newSchool._id, 'students', this.student._id, 'edit']);
          this.modalSv.showAlertModal('Success', 'student has successfully changed schools.');
        }, (err: ErrorModel) => {
          this.modalSv.showTranslatedErrorModal(err);
        });
      }

    });

  }

  onCopyStudentClicked() {

    this.copyFirstName = this.student.firstName;
    this.copyMiddleName = this.student.middleName;
    this.copyLastName = this.student.lastName;
    this.copySchool = null;
    this.isCopyVisible = true;

  }

  onCopyCloseClicked() {

    if (this.isCopying) {
      return;
    }

    this.isCopyVisible = false;

  }

  onCopySelectSchoolClicked() {

    this.schoolSelectSv.show().subscribe((schools) => {

      if (schools && schools.length > 0) {
        this.copySchool = schools[0];
      }

    });

  }

  isSelectingSchool(): boolean {

    return this.schoolSelectSv.isVisible;

  }

  canCopy(): boolean {

    return !!this.copyFirstName && !!this.copySchool && !this.isCopying;

  }

  onCopyConfirmClicked() {

    if (!this.canCopy()) {
      return;
    }

    this.isCopying = true;

    this.studentSv.copyStudent(this.student._id, this.copyFirstName, this.copyMiddleName, this.copyLastName, this.copySchool._id).subscribe((result) => {

      this.isCopying = false;
      this.isCopyVisible = false;

      let summary = 'New student id: ' + result.student._id + '. Copied';
      for (const key of Object.keys(result.copied)) {
        summary += ' ' + key + ': ' + result.copied[key] + ',';
      }
      summary += ' Remember to add the student to a group.';

      this.modalSv.showAlertModal('Success', summary);

    }, (err: ErrorModel) => {

      this.isCopying = false;
      this.modalSv.showTranslatedErrorModal(err);

    });

  }

}
